import { ModuleRegistry } from "ag-grid-community";
import {
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  MultiFilterModule,
  PivotModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  SideBarModule,
  TreeDataModule,
} from "ag-grid-enterprise";
import { forwardRef, useCallback, useMemo, useState } from "react";

import { KeyboardArrowRight } from "@mui/icons-material";
import { Box, Tooltip } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { isNil } from "lodash";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AgGridTableWrapper from "../../../../components/agGrid/AgGridTableWrapper";
import BorrowerAssociatedCommentsBadge from "../../../../components/common/Loan/BorrowerAssociatedCommentsBadge";
import PinnedCommentsModal from "../../../../components/common/Loan/Comments/PinnedCommentsModal";

ModuleRegistry.registerModules([
  SideBarModule,
  RowGroupingPanelModule,
  MultiFilterModule,
  RowGroupingModule,
  PivotModule,
  TreeDataModule,
  FiltersToolPanelModule,
  ColumnsToolPanelModule,
  SetFilterModule,
]);

const LoanBorrowersMinimalTable = forwardRef(
  (
    { rowData, quickFilterText, simpleTable = true, height, sx, gridOptions },
    ref
  ) => {
    const loanDrilldown = useSelector((state) => state.loanDrilldown);
    const [associatedComments, setAssociatedComments] = useState(null);
    const navigate = useNavigate();
    const { id: loanId } = useParams();
    const columnDefs = useMemo(
      () => [
        {
          headerName: "Name",
          field: "firstName",
          flex: 1,
          minWidth: 200,
          autoHeight: true,
          cellRenderer: (params) => {
            return (
              <>
                {params.data?.firstName} {params.data?.lastName}{" "}
                <BorrowerAssociatedCommentsBadge
                  borrowerId={params.data?._id}
                  onClick={(c) => {
                    console.log(c);
                    setAssociatedComments({
                      comments: c,
                      borrowerId: params.data?._id,
                    });
                  }}
                />
              </>
            );
          },
        },

        {
          field: "arrow",
          flex: 0,
          width: 100,
          cellStyle: { cursor: "pointer" },
          cellRenderer: () => {
            return (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  pr: 2.5,
                }}
              >
                <Tooltip title="Go To Borrower Details">
                  <KeyboardArrowRight className="thin" />
                </Tooltip>
              </Box>
            );
          },
        },
      ],
      []
    );

    const onCellClicked = useCallback(
      (params) => {
        if (params?.colDef?.field === "arrow") {
          setAssociatedComments(null);
          navigate(`/loan/${loanId}/borrowers/${params?.data?._id}`);
          return;
        }
      },
      [loanId, setAssociatedComments]
    );

    return (
      <AgGridTableWrapper height={height} simpleTable={simpleTable} sx={sx}>
        <AgGridReact
          ref={ref}
          rowData={rowData}
          columnDefs={columnDefs}
          quickFilterText={quickFilterText}
          onCellClicked={onCellClicked}
          gridOptions={gridOptions}
          // onFirstDataRendered={onFirstDataRendered}
          headerHeight={0}
          enableCellTextSelection
        />
        {!isNil(associatedComments) && (
          <PinnedCommentsModal
            title="Borrower Comments"
            show={associatedComments}
            fixed
            comments={associatedComments.comments}
            loan={loanDrilldown}
            // fileId={fileId}
            borrowerIds={[associatedComments.borrowerId]}
            onClose={() => setAssociatedComments(null)}
          />
        )}
      </AgGridTableWrapper>
    );
  }
);

export default LoanBorrowersMinimalTable;
